module.exports = __webpack_public_path__ + "2-o1.gif?882a728dbc99f4b8ee5ad263beb4b55c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/2-o1.gif
// module id = 638
// module chunks = 0